export const getDateTimeCache = (granularity: string = "MM"): string => {
    // YYYY-MM-DDTHH:mm:ss
    const lengths: Record<string, number> = {
        YYYY: 4,
        MM: 7,
        DD: 10,
        HH: 13,
        mm: 16,
        ss: 19,
    };

    const sliceGranularity: number =
        process.env.APP_ENV !== "production"
            ? lengths.mm
            : (lengths[granularity] ?? lengths.ss);

    return new Date()
        .toISOString()
        .slice(0, sliceGranularity)
        .replace(/[-T:]/g, "");
};
